module.exports = __webpack_public_path__ + "img/icon-money.ac12920a.svg";